import {ModalBackButton} from "src/core/common/components/modules/modal/modalComponents";
import Modal from "src/core/common/components/modules/modal/Modal";
import React from "react";
import Title from "src/core/common/components/modules/Title";
import styled, {useTheme} from "styled-components";
import useRouter from "src/core/common/hooks/useRouter";
import SelectionCard from "src/core/common/components/views/SelectionCard";
import useInventoryType, {InventoryTypes} from "src/core/inventories/useInventoryType";
import {MedicinalIcon} from "@ui";
import {RecreationalIcon} from "@ui";

function InventoryTypeModal({closeModal}) {
  const router = useRouter();
  const [, doSelectInventoryType] = useInventoryType();

  const selectInventoryType = (item) => {
    if (doSelectInventoryType(item)) {
      closeModal();
    }
  };

  return (
    <Modal isOpen={true} closeModalOverride={closeModal}>
      <ModalBackButton onClick={() => router.safeBack()} />
      <Container>
        <Title>Select your menu</Title>
        <DeliveryCardContainer>
          {inventoryTypes.map((inventoryType) => (
            <SelectionCard
              key={inventoryType.code}
              item={inventoryType}
              onClick={() => {
                selectInventoryType(inventoryType.code);
              }}
            />
          ))}
        </DeliveryCardContainer>
      </Container>
    </Modal>
  );
}

const inventoryTypes = [
  {
    code: InventoryTypes.RECREATIONAL,
    label: InventoryTypes.RECREATIONAL,
    icon: makeInventoryTypeIcon(RecreationalIcon),
    description: "",
  },
  {
    code: InventoryTypes.MEDICAL,
    label: InventoryTypes.MEDICAL,
    icon: makeInventoryTypeIcon(MedicinalIcon),
    description: "",
  },
];

function makeInventoryTypeIcon(Component) {
  return function InventoryTypeIcon() {
    const theme = useTheme();

    return <Component width={"24px"} height={"24px"} color={theme.v2.color.primary} />;
  };
}

const Container = styled.div`
  width: 450px;
  display: flex;
  flex-direction: column;
`;

const DeliveryCardContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export default InventoryTypeModal;
